<template>
  <div>
    鲜读
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
